import { render } from "./AddBackupEmailBox.vue?vue&type=template&id=3762dc96&scoped=true"
import script from "./AddBackupEmailBox.vue?vue&type=script&lang=js"
export * from "./AddBackupEmailBox.vue?vue&type=script&lang=js"

import "./AddBackupEmailBox.vue?vue&type=style&index=0&id=3762dc96&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3762dc96"]])

export default __exports__